// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Riprovare utilizzando una data completa simile alla seguente: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Gruppo',
  chart_labelSeries: () => 'Serie',
  chart_labelValue: () => 'Valore',
  checkboxSet_requiredMessageDetail: () => 'Obbligatorio',
  checkbox_requiredMessageDetail: () => 'Obbligatorio',
  close: () => 'Chiudi',
  collection_noData: () => 'Nessun dato da visualizzare.',
  collection_selectAllRows: () => 'Seleziona tutte le righe',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Seleziona la riga ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Non ordinabile',
  collection_sortEnabled: () => 'Ordinabile',
  confirmation: () => 'Conferma',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' di ' + p['totalCount'],
  dataVisualization_noData: () => 'Nessun dato da visualizzare',
  dataVisualization_stateSelected: () => 'Selezionato',
  dataVisualization_stateUnselected: () => 'Non selezionato',
  error: () => 'Errore',
  expandableList_expandCollapseInstructionText: () =>
    'Utilizzare i tasti freccia per espandere e comprimere',
  expandableList_groupCollapse: () => 'Compresso',
  expandableList_groupExpand: () => 'Espanso',
  filePicker_addFiles: () => 'Aggiungi file',
  filePicker_dropzonePrimaryText: () => 'Trascina selezione',
  filePicker_dropzoneSecondaryText: () => 'Selezionare un file o rilasciarne uno qui',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selezionare o rilasciare i file qui',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Impossibile caricare file di questo tipo: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Caricare un solo file alla volta',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Impossibile caricare i file del tipo ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'sconosciuto',
  formControl_clear: () => 'Cancella',
  formControl_day: () => 'Giorno',
  formControl_helpAvailable: () => 'Guida disponibile',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'È stato raggiunto il limite di ' +
    ((
      {
        one: '1 carattere',
        many: new Intl.NumberFormat('it').format(p['CHARACTER_LIMIT']) + ' di caratteri'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('it').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('it').format(p['CHARACTER_LIMIT']) + ' caratteri') +
    '.',
  formControl_loading: () => 'Caricamento',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Lunghezza massima ' + p['MAX_LENGTH'] + ' superata.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caratteri rimanenti.',
  formControl_month: () => 'Mese',
  formControl_readOnly: () => 'Sola lettura',
  formControl_requiredMessageDetail: () => 'Immettere un valore.',
  formControl_year: () => 'Anno',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Fine',
  gantt_labelLabel: () => 'Etichetta',
  gantt_labelRow: () => 'Riga',
  gantt_labelStart: () => 'Inizio',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nessuna sezione corrispondente trovata.',
  indexer_keyboardInstructionText: () => 'Premere Invio per selezionare un valore.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Tra ' + p['FROM_SECTION'] + ' e ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Toccare 2 volte e tenere premuto per immettere la modalità movimento,quindi trascinare su o giù per regolare il valore.',
  info: () => 'Informazioni',
  inputDateMask_date_cleared: () => 'Data cancellazione',
  inputDateMask_dayPlaceholder: () => 'gg',
  inputDateMask_empty_segment: () => 'Vuoto',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputNumber_converterParseError: () => 'Immettere un numero.',
  inputNumber_decrease: () => 'Riduci',
  inputNumber_increase: () => 'Aumenta',
  inputPassword_hidden: () => 'Password nascosta',
  inputPassword_hide: () => 'Nascondi password',
  inputPassword_show: () => 'Mostra password',
  list_suggestion: () => 'Suggerimento',
  messageToast_allMessagesClosed: () => 'Tutti i messaggi popup sono chiusi.',
  message_close: () => 'Chiudi',
  message_confirmation: () => 'Operazione riuscita',
  message_error: () => 'Errore',
  message_info: () => 'Informazioni',
  message_navigationFromMessagesRegion: () =>
    "Accesso all'area messaggi. Premere F6 per ritornare all'elemento evidenziato in precedenza.",
  message_navigationToMessagesRegion: () =>
    "L'area messaggi contiene nuovi messaggi. Premere F6 per andare all'area messaggi più recenti.",
  message_warning: () => 'Avvertenza',
  noData_message: () => 'Nessun elemento da visualizzare',
  overflowItemLabel: () => 'Altre schede',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'In corso',
  radio_helpForRadio: () => 'Guida per il pulsante di scelta',
  radio_requiredMessageDetail: () => 'Selezionare un valore.',
  selectMultiple_apply: () => 'Applica',
  selectMultiple_back: () => 'Indietro',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Premere Backspace o Canc per rimuovere il valore selezionato.',
  selectMultiple_selectedValues: () => 'Valori selezionati',
  selectMultiple_showSelectedValues: () => 'Mostra solo i valori selezionati.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valori selezionati.',
  select_addToList: () => 'Aggiungi a lista',
  select_addToListAvailable: () => 'Aggiungi a lista disponibile',
  select_moreSearchOptions: () => 'Altre opzioni di ricerca',
  select_moreSearchOptionsAvailable: () => 'Altre opzioni di ricerca disponibili',
  select_noMatchesFound: () => 'Nessuna corrispondenza trovata.',
  select_oneMatchFound: () => 'Una corrispondenza trovata',
  select_requiredMessageDetail: () => 'Selezionare un valore.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Trovate ' + p['TOTAL_SIZE'] + ' corrispondenze',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Trovate ' + p['TOTAL_SIZE'] + ' o più corrispondenze',
  selector_selected: () => 'Casella di controllo selezionata',
  selector_unselected: () => 'Casella di controllo non selezionata',
  tabBarNavigationList_removeCueText: () => 'Rimovibile',
  timeComponent_tooltipZoomIn: () => 'Ingrandisci',
  timeComponent_tooltipZoomOut: () => 'Riduci',
  train_current: () => 'Corrente',
  train_message_type: () => 'Tipo di messaggio',
  train_not_visited: () => 'Non visitato',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Passo ' + p['currentStep'] + ' di ' + p['numberOfSteps'],
  train_visited: () => 'Visitato',
  userAssistance_learnMore: () => 'Ulteriori informazioni',
  userAssistance_required: () => 'Obbligatorio',
  viz_drillable: () => 'Con drilling',
  warn: () => 'Avvertenza'
};
export default bundle;
